var _path, _rect, _rect2, _rect3, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBench(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1302 24.6829C29.3049 24.6829 15.311 25.2683 14.7025 25.2683C14.0941 25.2683 13.4856 20 14.7025 20C15.9194 20 29.3049 20 30.5218 20.5854C31.7387 21.1707 39.6483 25.8537 39.6483 25.8537C39.6483 25.8537 42 36.9756 42 37.561C42 38.1463 39.5663 38.1463 39.5663 37.561C39.5663 36.9756 37.823 28.7805 37.2146 28.1951C36.6061 27.6098 32.9555 24.6829 31.1302 24.6829Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.01864
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 27,
    width: 29,
    height: 5,
    rx: 1.01864,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 31,
    width: 3,
    height: 7,
    rx: 1.01864,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 4,
    height: 7,
    rx: 1.01864,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19C4.99999 19 4.99999 25 8.99999 25C13 25 13 19 9 19Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.01864
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 5.99068,
    fill: "black",
    stroke: "black",
    strokeWidth: 1.01864
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8126 16.4842C14.8119 16.4995 14.8115 16.5149 14.8115 16.5304V23.0781C14.8115 23.6407 15.2676 24.0968 15.8302 24.0968H17.4722C18.0348 24.0968 18.4908 23.6407 18.4908 23.0781V16.5304C18.4908 16.5149 18.4905 16.4995 18.4898 16.4841C17.9053 16.6494 17.2885 16.7378 16.6511 16.7378C16.0137 16.7378 15.397 16.6494 14.8126 16.4842Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/bench.e1e4fd69da6effea42239c2ba28c7f63.svg";
export { ForwardRef as ReactComponent };